var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn-nav-mob",attrs:{"type":"button"}},[_c('span',{staticClass:"a11y-solo-lectura"},[_vm._v("Menú")]),_c('span',{staticClass:"btn-icon"}),_c('span',{staticClass:"btn-text"})])
}]

export { render, staticRenderFns }